export {toJSONSchema} from './entity-schema-to-json-schema';
export {labels as typeLabelsMap, ModelTypes} from './type-label-mapping';



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/core/utils/json-schema/index.ts